import React from "react";
import "../../../styles/components/OurWorkAndClients.css";

const OurWorkAndClients = () => {
  return (
    <section className="our-work-and-clients">
      <div id="our-work" className="our-work">
        <div className="title-container">
            <h2>Our Work_</h2>
        </div>
        <div className="work-gallery">
          <img src="/images/work/emporium.png" alt="Emporium Work" />
          <img src="/images/work/fallme.png" alt="Fall Me Magazine" />
          <img src="/images/work/cheezious.png" alt="Cheezious Signboard" />
          <img src="/images/work/emporiumbranding.png" alt="Emporium Branding Kit" />
        </div>
      </div>

      {/* Our Clients Section */}
      <div id="our-clients" className="our-clients">
        <div className="title-container">
            <h2>Our Clients_</h2>
        </div>
        <div className="clients-gallery">
          <img src="/images/clients/rootbloom.png" alt="Root Bloom" />
          <img src="/images/clients/goldencity.png" alt="Golden City" />
          <img src="/images/clients/cryptoclub.png" alt="Crypto Club" />
          <img src="/images/clients/pleasedoit.png" alt="Please Do It" />
          <img src="/images/clients/happi.png" alt="Happi" />
          <img src="/images/clients/brushframe.png" alt="Brush Frame" />
          <img src="/images/clients/arumaheaven.png" alt="Aruma Heaven" />
          <img src="/images/clients/akilamodels.png" alt="Akila Models" />
          <img src="/images/clients/motomavs.png" alt="Moto Mavs" />
          <img src="/images/clients/fountain.png" alt="Fountain" />
          <img src="/images/clients/horse.png" alt="Horse" />
          <img src="/images/clients/sourceimpact.png" alt="Source Impact" />
          <img src="/images/clients/aline.png" alt="Aline" />
          <img src="/images/clients/victor.png" alt="Victor & Associates" />
          <img src="/images/clients/skingently.png" alt="Skin Gently" />
          <img src="/images/clients/progressiveedge.png" alt="Progressive Edge" />
          <img src="/images/clients/oldex.png" alt="Oldex" />
          <img src="/images/clients/emporium.png" alt="Emporium" />
          <img src="/images/clients/meditech.png" alt="Meditech Billing Services" />
          <img src="/images/clients/cdrs.png" alt="CDRS" />

        </div>
      </div>
    </section>
  );
};

export default OurWorkAndClients;
